import React from 'react';
import TextField, { TextFieldProps } from '@mui/material/TextField';

interface InputFieldProps extends Omit<TextFieldProps, 'InputLabelProps' | 'InputProps'> {
    InputProps?: TextFieldProps['InputProps'];
}

const InputField = React.forwardRef<HTMLDivElement, InputFieldProps>((props, ref) => {
    const { disabled, InputProps, ...rest } = props;

    return (
        <TextField
            ref={ref}
            {...rest}
            disabled={disabled}
            InputLabelProps={{
                shrink: true,
            }}
            InputProps={{
                notched: false,
                ...InputProps,
            }}
            sx={{
                '& .MuiInputLabel-root': {
                    position: 'relative',
                    transform: 'none',
                    fontSize: '14px',
                    fontWeight: 500,
                    fontFamily: "'Plus Jakarta Sans', sans-serif",
                    lineHeight: '20px',
                    color: disabled ? '#939393' : '#FFFFFF',
                    marginBottom: '8px',
                    '&.Mui-focused': {
                        color: disabled ? '#939393' : '#FFFFFF',
                    },
                },
                '& .MuiOutlinedInput-root': {
                    background: disabled ? '#424242' : '#282C30',
                    borderRadius: '8px',
                    fontFamily: "'Plus Jakarta Sans', sans-serif",
                    fontSize: '14px',
                    fontWeight: 500,
                    lineHeight: '20px',
                    '& fieldset': {
                        borderColor: disabled ? '#939393' : '#fff',
                        borderWidth: '1px',
                    },
                    '&:hover fieldset': {
                        borderColor: disabled ? '#939393' : '#fff',
                    },
                    '&.Mui-focused fieldset': {
                        borderColor: disabled ? '#939393' : '#5447DE',
                        borderWidth: '1px',
                    },
                    '&.Mui-disabled fieldset': {
                        borderColor: '#939393',
                    },
                    '&.Mui-error fieldset': {
                        borderColor: disabled ? '#939393' : '#E45858',
                    },
                },
                '& .MuiOutlinedInput-input': {
                    fontSize: '14px',
                    fontWeight: 500,
                    fontFamily: "'Plus Jakarta Sans', sans-serif",
                    lineHeight: '20px',
                    color: '#FFFFFF',
                    '&::placeholder': {
                        color: '#939393',
                        opacity: 1,
                    },
                    '&.Mui-disabled': {
                        WebkitTextFillColor: '#939393',
                        color: '#939393',
                    },
                },
                '& .MuiFormHelperText-root': {
                    marginLeft: 0,
                    marginTop: '4px',
                    fontSize: '12px',
                    fontWeight: 400,
                    fontFamily: "'Plus Jakarta Sans', sans-serif",
                    lineHeight: '16px',
                    color: disabled ? '#939393' : '#F9F9F9',
                    '&.Mui-error': {
                        color: '#E45858',
                    },
                },
                ...props.sx,
            }}
        />
    );
});

InputField.displayName = 'InputField';

export default InputField;
